function onboardingTwoFeatureDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/onboarding-two-feature/onboarding-two-feature-dialog.html?$$REVISION$$'
  }
}

export { onboardingTwoFeatureDialog }
